import Cookies from 'js-cookie';
import { useState } from 'react';
import { post } from 'utils/network';
import { Modal } from './Modal';
import { Button } from '../button/Button';
import styles from './Modal.module.scss';
import { ApiRoute, Route } from '../../../utils/config';

// eslint-disable-next-line no-empty-pattern
export function CookieModal(): JSX.Element {
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const noop = () => { /* noop */
  };
  return (
    <>
      {(Cookies.get('do_not_sell') === undefined && showCookieBanner === true) && (
        <Modal
          isOpen
          onClose={noop}
          withCloseButton={false}
          size="full"
          classNames={{
            inner: styles.cookie_modal__container_inner,
            body: styles.cookie_modal__container_content,
          }}
        >
          <div className={styles.cookie_modal__headline}>
            Purple Carrot Cookies (Yum!)
          </div>
          <div className={styles.cookie_modal__content}>
            <div className={styles.cookie_modal__text_container}>
              <p>
                We use cookies to remember your preferences and improve your shopping experience.
                By continuing, you agree to our
                {' '}
                <a
                  href={Route.TERMS}
                  className={styles.cookie_modal__link}
                >
                  Terms of Use
                </a>
                {' '}
                and our
                {' '}
                <a
                  href={Route.PRIVACY}
                  className={styles.cookie_modal__link}
                >
                  Privacy Policy
                </a>
                . You agree that we and our third-party partners may
                collect and use your information, including through cookies, pixels
                and similar technologies.
              </p>
            </div>
            <div className={styles.cookie_modal__button_container}>
              <Button
                style={{ background: '#297B03' }}
                className={`${styles.cookie_modal__button}`}
                text="Accept All"
                onClick={async () => {
                  setShowCookieBanner(false);
                  await post<void>(`${ApiRoute.DO_NOT_SELL}`);
                }}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
